<div class="ranking-component">
  <div class="row header" #header>
    <div class="col-10">
      <mat-icon class="icon-order" svgIcon="ranking"></mat-icon>
      <span class="title">{{ title }}</span>
    </div>
    <div class="col-2 txt-right">
      <mat-icon class="icon-close-btn pointer" (click)="close()" svgIcon="close-btn"></mat-icon>
    </div>
  </div>

  <div *ngIf="loading" class="spinner-get">
    <app-spinner-loading></app-spinner-loading>
  </div>

  <div class="iframe-modal" *ngIf="!loading">
    <iframe src="{{urlIframe}}" frameborder="0" scrolling="yes"></iframe>
  </div>

</div>